<template>
  <div class="view-checkout-builder">
    <base-header v-if="isDesktop" />

    <div v-if="!loading" class="builder-container">
      <checkout-builder-header class="builder-header" />

      <div class="builder-content">
        <aside class="d-none d-lg-block" v-if="editing">
          <settings-menu />
        </aside>
        <section :class="{ editing }">
          <checkout-builder />
        </section>
      </div>
    </div>
    <div class="text-center my-9" v-else>
      <b-spinner variant="primary" />
    </div>
  </div>
</template>

<script>
import CheckoutBuilder from "@/components/product/checkout/builder/CheckoutBuilder.vue";
import CheckoutBuilderHeader from "@/components/product/checkout/builder/CheckoutBuilderHeader";
import SettingsMenu from "@/components/product/checkout/builder/SettingsMenu.vue";
import BaseHeader from "@/components/layout/BaseHeader.vue";
import { mapState } from "vuex";

export default {
  components: {
    CheckoutBuilderHeader,
    CheckoutBuilder,
    SettingsMenu,
    BaseHeader
  },
  data() {
    return {
      loading: false,
      menuModal: false
    };
  },
  computed: {
    ...mapState("checkoutBuilder", ["editing"]),
    isDesktop() {
      return window.innerWidth >= 992;
    }
  },
  methods: {
    setCheckoutState(checkout_build) {
      this.$store.dispatch("checkoutBuilder/setCheckoutState", checkout_build);
    }
  },
  mounted() {
    this.loading = true;
    this.$store.commit("checkoutBuilder/setEditing", true);
    this.$store
      .dispatch("product/getProduct", this.$route.params.id)
      .then(({ checkout_build }) => {
        this.setCheckoutState({ ...checkout_build });
      })
      .finally(() => (this.loading = false));
  }
};
</script>

<style lang="scss">
.builder-container {
  display: flex;
  position: relative;
  flex-direction: column;

  .builder-content {
    display: flex;
  }
  @media screen and (min-width: 992px) {
    .builder-header {
      margin-top: var(--header-height);
    }
  }

  aside {
    width: 260px;
    flex: 0 0 260px;
    min-height: 100%;
    border-right: 1px solid var(--dark-10);
  }

  section {
    min-height: 100%;
    width: 100%;
    background: var(--bg-2);
    @media screen and (min-width: 992px) {
      padding: 28px 80px;
    }
    // &.editing {
    //   @media screen and (min-width: 992px) {
    //     margin-left: 343px;
    //   }
    // }
  }
}
.modal-body {
  padding: 1rem 0;
}
</style>
